module.exports = __webpack_public_path__ + "img/3超细颗粒度检测.601ce827.png";